import CookiesManager from "../core/business/CookiesManager";

export default class CookieAmenityServiceManager extends CookiesManager {
    constructor() {
        super()
        this.key = "amenity_service_data"
    }
}


// WEBPACK FOOTER //
// ./src/business/CookieAmenityServiceManager.js